import { Routes } from '@angular/router';
import { unsavedChangesGuard } from './pial/pages/emploi-du-temps/shared/unsaved-changes.guard';
import { AuthGuard } from './tools/auth-guard.service';

export const routes: Routes = [
  // Layout existant (accueil, login, etc.)
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then((m) => m.LayoutComponent),
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pial/pages/pial-select/pial-select.component').then((m) => m.PialSelectComponent),
        data: { title: 'Sélection PIAL' },
      },
    ],
  },

  // Formulaire PIAL (ajout/modif, sans layout PIAL)
  { path: 'pial-form', loadComponent: () => import('./pial/pages/pial-form/pial-form.component').then((m) => m.PialFormComponent), canActivate: [AuthGuard] },
  {
    path: 'pial-form/:idPial',
    loadComponent: () => import('./pial/pages/pial-form/pial-form.component').then((m) => m.PialFormComponent),
    canActivate: [AuthGuard],
  },

  // Layout PIAL (module principal)
  {
    path: 'pial/:idPial',
    loadComponent: () => import('./pial/layout/pial-layout.component').then((m) => m.PialLayoutComponent),
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadComponent: () => import('./pial/pages/dashboard/dashboard.component').then((m) => m.DashboardComponent) },
      { path: 'edit', loadComponent: () => import('./pial/pages/pial-edit/pial-edit.component').then((m) => m.PialEditComponent) },
      { path: 'ecoles', loadComponent: () => import('./pial/pages/ecoles/ecoles-liste.component').then((m) => m.EcolesListeComponent) },
      { path: 'ecoles/new', loadComponent: () => import('./pial/pages/ecoles/ecole-form/ecole-form.component').then((m) => m.EcoleFormComponent) },
      { path: 'ecoles/:idEcole', loadComponent: () => import('./pial/pages/ecoles/ecole-detail/ecole-detail.component').then((m) => m.EcoleDetailComponent) },
      { path: 'ecoles/:idEcole/edit', loadComponent: () => import('./pial/pages/ecoles/ecole-form/ecole-form.component').then((m) => m.EcoleFormComponent) },
      {
        path: 'ecoles/:idEcole/classes/new',
        loadComponent: () => import('./pial/pages/ecoles/classe-form/classe-form.component').then((m) => m.ClasseFormComponent),
      },
      {
        path: 'ecoles/:idEcole/classes/:idClasse/edit',
        loadComponent: () => import('./pial/pages/ecoles/classe-form/classe-form.component').then((m) => m.ClasseFormComponent),
      },
      {
        path: 'ecoles/:idEcole/affectations/new',
        loadComponent: () => import('./pial/pages/ecoles/affectation-form/affectation-form.component').then((m) => m.AffectationFormComponent),
      },
      {
        path: 'ecoles/:idEcole/affectations/:idAffectation/edit',
        loadComponent: () => import('./pial/pages/ecoles/affectation-form/affectation-form.component').then((m) => m.AffectationFormComponent),
      },
      { path: 'aeshs', loadComponent: () => import('./pial/pages/aeshs/aeshs-liste.component').then((m) => m.AeshsListeComponent) },
      { path: 'aeshs/new', loadComponent: () => import('./pial/pages/aeshs/aesh-form/aesh-form.component').then((m) => m.AeshFormComponent) },
      { path: 'aeshs/:idAesh', loadComponent: () => import('./pial/pages/aeshs/aesh-detail/aesh-detail.component').then((m) => m.AeshDetailComponent) },
      { path: 'aeshs/:idAesh/edit', loadComponent: () => import('./pial/pages/aeshs/aesh-form/aesh-form.component').then((m) => m.AeshFormComponent) },
      {
        path: 'aeshs/:idAesh/absences/new',
        loadComponent: () => import('./pial/pages/aeshs/absence-form/absence-form.component').then((m) => m.AbsenceFormComponent),
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pial/pages/notifications/notifications-liste.component').then((m) => m.NotificationsListeComponent),
      },
      {
        path: 'notifications/new',
        loadComponent: () => import('./pial/pages/notifications/notification-form/notification-form.component').then((m) => m.NotificationFormComponent),
      },
      {
        path: 'notifications/:idNotification/edit',
        loadComponent: () => import('./pial/pages/notifications/notification-form/notification-form.component').then((m) => m.NotificationFormComponent),
      },
      { path: 'repartition', loadComponent: () => import('./pial/pages/repartition/repartition.component').then((m) => m.RepartitionComponent) },
      {
        path: 'emploi-du-temps/aesh/:idAesh/:slug',
        loadComponent: () => import('./pial/pages/emploi-du-temps/by-aesh/emploi-du-temps-aesh.component').then((m) => m.EmploiDuTempsAeshComponent),
        data: { fullPage: true },
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'emploi-du-temps/notification/:idNotification/:slug',
        loadComponent: () =>
          import('./pial/pages/emploi-du-temps/by-notification/emploi-du-temps-notification.component').then((m) => m.EmploiDuTempsNotificationComponent),
        data: { fullPage: true },
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'emploi-du-temps/classe/:idClasse/:slug',
        loadComponent: () => import('./pial/pages/emploi-du-temps/by-classe/emploi-du-temps-classe.component').then((m) => m.EmploiDuTempsClasseComponent),
        data: { fullPage: true },
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'semainier-test',
        loadComponent: () => import('./pial/pages/semainier-test/semainier-test.component').then((m) => m.SemainierTestComponent),
        data: { fullPage: true },
      },
    ],
  },

  // Route publique préférences AESH (sans auth, sans layout)
  { path: 'preferences/:token', loadComponent: () => import('./pial/pages/preferences/preferences-aesh.component').then((m) => m.PreferencesAeshComponent) },

  // Profil (protégé)
  { path: 'profile', loadComponent: () => import('./pages/profile/profile.component').then((m) => m.ProfileComponent), canActivate: [AuthGuard] },

  // MFA pages (public - auth via cookie mfa challenge)
  { path: 'mfa-verify', loadComponent: () => import('./pages/mfa-verify/mfa-verify.component').then((m) => m.MfaVerifyComponent) },
  { path: 'mfa-setup', loadComponent: () => import('./pages/mfa-setup/mfa-setup.component').then((m) => m.MfaSetupComponent) },

  // Sessions (protégé)
  { path: 'sessions', loadComponent: () => import('./pages/sessions/sessions.component').then((m) => m.SessionsComponent), canActivate: [AuthGuard] },

  // Auth pages
  { path: 'logout', loadComponent: () => import('./pages/logout/logout.component').then((m) => m.LogoutComponent) },
  { path: 'login', loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent) },
  { path: 'signup', loadComponent: () => import('./pages/signup/signup.component').then((m) => m.SignupComponent) },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'reset-password/confirm',
    loadComponent: () =>
      import('./pages/reset-password/reset-password-mail-sent/reset-password-mail-sent.component').then((m) => m.ResetPasswordMailSentComponent),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () => import('./pages/reset-password/reset-password-form/reset-password-form.component').then((m) => m.ResetPasswordFormComponent),
  },
  { path: 'confirm-email/:token', loadComponent: () => import('./pages/signup/confirm-email/confirm-email.component').then((m) => m.ConfirmEmailComponent) },
  // Pages légales (publiques)
  {
    path: 'mentions-legales',
    loadComponent: () => import('./pages/legal/mentions-legales/mentions-legales.component').then((m) => m.MentionsLegalesComponent),
  },
  { path: 'policy', loadComponent: () => import('./pages/legal/policy/policy.component').then((m) => m.PolicyComponent) },
  { path: 'cgu', loadComponent: () => import('./pages/legal/cgu/cgu.component').then((m) => m.CguComponent) },
  { path: 'cgv', loadComponent: () => import('./pages/legal/cgv/cgv.component').then((m) => m.CgvComponent) },
  { path: 'cookies', loadComponent: () => import('./pages/legal/cookies/cookies.component').then((m) => m.CookiesComponent) },
];
